// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"af4f5810","455":"2c3ce442","904":"46a88169","977":"02371409"}[chunkId] + ".chunk.js";
};